(function () {

  function initAutelSpecification() {

    const output = document.getElementById(
      'autelDatabaseSpecification'
    );

    const legacy = document.getElementById(
      'autelLegacySpecification'
    );

    if (!output || !legacy) return;

    /* 检查数据库 */
    if (
      !window.AUTEL_COMPARE_DATA ||
      !window.AUTEL_COMPARE_DATA.DATA
    ) {
      return;
    }

    const database = window.AUTEL_COMPARE_DATA.DATA;

    /* ========================================
       1. 获取当前产品型号
    ======================================== */

    let modelName = '';

    const currentModelButton = document.querySelector(
      '#autelScannerCompare [data-current-product="true"][data-model]'
    );

    if (currentModelButton) {
      modelName = currentModelButton.dataset.model || '';
    }

    /* 如果 Comparison 当前型号没识别到
       再尝试根据产品标题匹配 */
    if (!modelName) {

      const compareRoot = document.getElementById(
        'autelScannerCompare'
      );

      const productTitle = compareRoot
        ? compareRoot.dataset.currentProductTitle || ''
        : '';

      if (productTitle) {

        const models = Object.keys(database).sort(
          function (a, b) {
            return b.length - a.length;
          }
        );

        modelName =
          models.find(function (model) {
            return productTitle
              .toLowerCase()
              .includes(model.toLowerCase());
          }) || '';
      }
    }

    /* ========================================
       2. 数据库没有这个型号
       保留原 Specification
    ======================================== */

    if (!modelName || !database[modelName]) {

      output.style.display = 'none';
      legacy.style.display = '';

      return;
    }

    const data = database[modelName];

    /* ========================================
       3. HTML 转义
    ======================================== */

    function escapeHTML(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    /* ========================================
       4. 格式化字段值
    ======================================== */

    function formatValue(value, key) {

      if (
        value === null ||
        value === undefined ||
        value === '' ||
        value === '/'
      ) {
        return '<span class="autel-spec-na">—</span>';
      }

      const stringValue = String(value).trim();

      if (
        stringValue === '√' ||
        stringValue === 'V'
      ) {
        return '<span class="autel-spec-yes">✓</span>';
      }

      if (
        stringValue === 'X' ||
        stringValue.toLowerCase() === 'not support'
      ) {
        return '<span class="autel-spec-no">—</span>';
      }

      if (key === 'Price') {

        const number = Number(value);

        if (!Number.isNaN(number)) {
          return (
            '<span class="autel-spec-price">$' +
            number.toLocaleString('en-US') +
            '</span>'
          );
        }
      }

      return escapeHTML(stringValue)
        .replace(/\n/g, '<br>');
    }

    /* ========================================
       5. Specification 分类
    ======================================== */

    const groups = [

      {
        title: 'Hardware & Device',
        fields: [
          ['Price', 'Price'],
          ['RAM', 'RAM'],
          ['ROM', 'Storage'],
          ['battery capacity', 'Battery'],
          ['Android version', 'Android'],
          ['Screen size', 'Screen Size'],
          ['Screen resolution', 'Screen Resolution'],
          ['camera', 'Camera'],
          ['HDMI', 'HDMI'],
          ['Weight(kg)', 'Weight'],
          ['VCI', 'VCI']
        ]
      },

      {
        title: 'Diagnostic Functions',
        fields: [
          [
            'Basic functions (read code and clear code)',
            'Basic Diagnostics'
          ],
          [
            'Service functions',
            'Service Functions'
          ],
          [
            'Special functions',
            'Special Functions'
          ],
          [
            'Active Test',
            'Bi-Directional / Active Test'
          ],
          ['Auto VIN', 'AutoVIN'],
          ['SCAN VIN', 'VIN Scan'],
          ['Scan License', 'License Plate Scan'],
          ['Pre&Post Scan', 'Pre & Post Scan'],
          ['Remote Desk', 'Remote Desk']
        ]
      },

      {
        title: 'Coding & Programming',
        fields: [
          [
            'Benz online programming',
            'Mercedes-Benz Online Programming'
          ],
          [
            'BMW online programming',
            'BMW Online Programming'
          ],
          [
            'Benz online coding (SCN)',
            'Mercedes-Benz Online Coding (SCN)'
          ],
          [
            'BMW online coding',
            'BMW Online Coding'
          ],
          [
            'Audi online coding',
            'Audi Online Coding'
          ],
          [
            'Porsche online coding',
            'Porsche Online Coding'
          ],
          [
            'VW online coding',
            'VW Online Coding'
          ],
          [
            'BMW Hidden Brush',
            'BMW Hidden Functions'
          ],
          [
            'VW、Audi、Skoda Hidden Brush',
            'VW / Audi / Skoda Hidden Functions'
          ]
        ]
      },

      {
        title: 'Protocols & Advanced Diagnostics',
        fields: [
          [
            'Diagnostic standard D-PDU/RP1210',
            'D-PDU / RP1210'
          ],
          [
            'Bus protocol DoIP/CAN FD',
            'DoIP / CAN FD'
          ],
          [
            'Diagnostic system topology',
            'Diagnostic Topology'
          ],
          [
            'Remote experts',
            'Remote Expert'
          ],
          [
            'AccuFix',
            'AccuFix'
          ],
          [
            'Report management (reports on the cloud)',
            'Cloud Report Management'
          ]
        ]
      },

      {
        title: 'Expansion & Accessories',
        fields: [
          [
            'Oscilloscope function (with MP408)',
            'Oscilloscope / MP408'
          ],
          [
            'Endoscope function (with MV108S)',
            'Endoscope / MV108S'
          ],
          [
            'Battery detection (BT506)',
            'Battery Test / BT506'
          ],
          [
            'Add EV box upgraded to EV product',
            'EV Diagnostics Expansion'
          ],
          [
            '"TPMS comprehensive functions"\n(sensor programming, sensor activation, etc.)',
            'Complete TPMS Functions'
          ]
        ]
      },

      {
        title: 'Software & Support',
        fields: [
          [
            'language support',
            'Language Support'
          ],
          [
            'Free upgrade years',
            'Free Software Updates'
          ],
          [
            'Renault gateway support',
            'Renault Gateway'
          ],
          [
            'North American FCA Auto auth support',
            'North American FCA AutoAuth'
          ],
          [
            'European FCA SGW support',
            'European FCA SGW'
          ]
        ]
      }

    ];

    /* ========================================
       6. 生成 HTML
    ======================================== */

    let html = '';

    html +=
      '<div class="autel-spec-header">' +
        '<h2>' +
          escapeHTML(modelName) +
          ' Specifications' +
        '</h2>' +
      '</div>';

    groups.forEach(function (group) {

      const rows = [];

      group.fields.forEach(function (field) {

        const key = field[0];
        const label = field[1];

        if (
          !Object.prototype.hasOwnProperty.call(
            data,
            key
          )
        ) {
          return;
        }

        rows.push(
          '<div class="autel-spec-row">' +
            '<div class="autel-spec-label">' +
              escapeHTML(label) +
            '</div>' +
            '<div class="autel-spec-value">' +
              formatValue(data[key], key) +
            '</div>' +
          '</div>'
        );
      });

      if (!rows.length) return;

      html +=
        '<section class="autel-spec-group">' +

          '<div class="autel-spec-group-title">' +
            escapeHTML(group.title) +
          '</div>' +

          '<div class="autel-spec-table">' +
            rows.join('') +
          '</div>' +

        '</section>';
    });

    /* ========================================
       7. 显示数据库版
    ======================================== */

    output.innerHTML = html;

    output.style.display = '';
    legacy.style.display = 'none';

    output.dataset.model = modelName;
  }

  /* ========================================
     初始化
  ======================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAutelSpecification
    );

  } else {

    initAutelSpecification();

  }

})();